"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_device__overview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:none;}.cls-2{stroke:#666;}.cls-2,.cls-3{stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}.cls-3{stroke:#e60000;}")), /*#__PURE__*/React.createElement("title", null, "device-overview-mid"), /*#__PURE__*/React.createElement("g", {
    id: "Apps_ic_mid"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 192,
    height: 192
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.58,165.42h-49a8.17,8.17,0,0,1-8.17-8.17h0a8.16,8.16,0,0,1,8.17-8.16h8.57",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 55.16,
    cy: 128.67,
    r: 28.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 55.16,
    cy: 128.67,
    r: 4.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.17,149.09h51.46a30.63,30.63,0,0,0,30.62-30.63h0V57.21a30.62,30.62,0,0,0-30.62-30.63H65.37A30.62,30.62,0,0,0,34.75,57.21v51.45",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "157.25 116.42 173.59 116.42 173.59 59.25 157.25 59.25"
  })));
}

var _default = ic_device__overview;
exports.default = _default;